import { render, staticRenderFns } from "./ModerateFacebookComment.vue?vue&type=template&id=0b8cbef8&scoped=true&"
import script from "./ModerateFacebookComment.vue?vue&type=script&lang=js&"
export * from "./ModerateFacebookComment.vue?vue&type=script&lang=js&"
import style0 from "./ModerateFacebookComment.vue?vue&type=style&index=0&id=0b8cbef8&lang=scss&scoped=true&"
import style1 from "./ModerateFacebookComment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8cbef8",
  null
  
)

export default component.exports